var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1435,
    height: 702,
    viewBox: "0 0 1435 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263 -2.19345e-05C337 -2.19345e-05 401.667 14.6666 457 43.9999C512.333 73.3333 555 114.667 585 168C615.667 220.667 631 281.667 631 351C631 419.667 615.667 480.667 585 534C555 587.333 512 628.667 456 658C400.667 687.333 336.333 702 263 702H2.71201e-06V-2.19345e-05H263ZM252 554C316.667 554 367 536.333 403 501C439 465.667 457 415.667 457 351C457 286.333 439 236 403 200C367 164 316.667 146 252 146H171V554H252ZM897.563 137V279H1126.56V411H897.563V565H1156.56V702H726.563V-2.19345e-05H1156.56V137H897.563ZM1926.58 -2.19345e-05L1677.58 702H1463.58L1214.58 -2.19345e-05H1396.58L1570.58 530L1745.58 -2.19345e-05H1926.58Z",
    fill: "white",
    fillOpacity: 0.24
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/DEV.84883baa87c7e0243810ad866a1ed929.svg";
export { ForwardRef as ReactComponent };